import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { BookingResponse } from 'app/typings/core/admin/bookings/booking';
import type { CreateBookingVoucherForm } from 'app/typings/core/admin/bookings/bookingForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type CreateBookingVoucherParams = {
  code: string;
  payload: CreateBookingVoucherForm;
};

export function useCreateBookingVoucher() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ code, payload }: CreateBookingVoucherParams) =>
      apiMutation(
        'POST',
        { path: ENDPOINTS.createBookingVoucher, params: { bookingCode: code } },
        payload
      ) as Promise<BookingResponse>,
    onSuccess: (_, variables) => {
      message.success('Booking voucher successfully created');

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.booking, { code: variables.code }],
      });
    },
    onError: () => {
      message.error('Failed to create booking voucher');
    },
  });
}
